<button class="close-icon" mat-dialog-close mat-icon-button tabindex="-1">
    <mat-icon>close</mat-icon>
</button>
<button class="tab-trap" tabindex="0"></button>

<div class="dialog-content {{ mode }}">
    <ng-container [ngTemplateOutlet]="modeTemplate"></ng-container>
</div>

<ng-template #regular>
    <div class="gradient-background"></div>
    <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.title' | translate: regularData" class="title"></div>
    <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.p1' | translate: regularData" class="credit-details"></div>
    <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.p2' | translate: regularData" class="price"></div>
    <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.p3' | translate: regularData" class="charge-details"></div>
    <div class="actions">
        <button (click)="purchaseSubscription($event)"
                [disabled]="!regularAgree.checked"
                class="action"
                color="primary"
                mat-flat-button>
                <span *spinOn="isFormSubmitting"
                      [innerHTML]="'deliveryDefenseSubscription.' + mode + '.action.purchase' | translate: regularData"></span>
        </button>
    </div>
    <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.condition' | translate: regularData"
         class="condition"></div>
    <div class="agree">
        <mat-checkbox #regularAgree class="ups-checkbox">
            <span>
                I agree to the <upsc-delivery-defense-terms-conditions-link></upsc-delivery-defense-terms-conditions-link>.
            </span>
        </mat-checkbox>
    </div>
</ng-template>

<ng-template #complimentary>
    <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.title' | translate: complimentaryData"
         class="title"></div>
    <div class="logo">
        <img alt="DeliverDefense" src="assets/images/logos/logo-dd-shipping-intelligence.svg">
    </div>
    <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.p1' | translate: complimentaryData"
         class="message"></div>
    <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.condition' | translate: complimentaryData"
         class="condition"></div>
    <div class="agree">
        <mat-checkbox #complimentaryAgree class="ups-checkbox">
            <span>
                I agree to the <upsc-delivery-defense-terms-conditions-link></upsc-delivery-defense-terms-conditions-link>.
            </span>
        </mat-checkbox>
    </div>
    <div class="actions">
        <button (click)="keepSubscription($event)"
                [disabled]="!complimentaryAgree.checked"
                class="action"
                color="primary"
                mat-flat-button>
                <span *spinOn="isFormSubmitting"
                      [innerHTML]="'deliveryDefenseSubscription.' + mode + '.action.yes' | translate: complimentaryData"></span>
        </button>
        <button (click)="cancelSubscription($event)"
                [disabled]="isFormSubmitting"
                class="action ups-stroked-button"
                color="primary"
                mat-stroked-button>
            <span [innerHTML]="'deliveryDefenseSubscription.' + mode + '.action.no' | translate: complimentaryData"></span>
        </button>
    </div>
</ng-template>

<ng-template #form>
    <div class="introduction">
        <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.title' | translate" class="title"></div>
        <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.p1' | translate" class="credit-details"></div>
    </div>
    <form [formGroup]="formGroup">
        <div class="inputs">
            <mat-form-field class="half-width">
                <mat-label>{{ 'deliveryDefenseSubscription.' + mode + '.form.firstName.label' | translate }}</mat-label>
                <input formControlName="firstName" matInput required type="text">
                <mat-error>{{ 'deliveryDefenseSubscription.' + mode + '.form.firstName.error.required' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field class="half-width">
                <mat-label>{{ 'deliveryDefenseSubscription.' + mode + '.form.lastName.label' | translate }}</mat-label>
                <input formControlName="lastName" matInput required type="text">
                <mat-error>{{ 'deliveryDefenseSubscription.' + mode + '.form.lastName.error.required' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'deliveryDefenseSubscription.' + mode + '.form.phone.label' | translate }}</mat-label>
                <input formControlName="phone" matInput required type="tel">
                <mat-error>{{ 'deliveryDefenseSubscription.' + mode + '.form.phone.error.required' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'deliveryDefenseSubscription.' + mode + '.form.email.label' | translate }}</mat-label>
                <input formControlName="email" matInput required type="email">
                <mat-error>{{ 'deliveryDefenseSubscription.' + mode + '.form.email.error.required' | translate }}</mat-error>
            </mat-form-field>
        </div>
        <div class="actions">
            <button (click)="requestMoreScores($event)"
                    [disabled]="!formGroup.valid"
                    class="action"
                    color="primary"
                    mat-flat-button>
                <span *spinOn="isFormSubmitting"
                      [innerHTML]="'deliveryDefenseSubscription.' + mode + '.action.submit' | translate"></span>
            </button>
        </div>
    </form>
</ng-template>

<ng-template #upgrade>
    <div class="dialog-header">
        <img alt="DeliveryDefense" src="assets/images/logos/logo-dd-shipping-intelligence.svg">
        <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.remark' | translate: upgradeData" class="remark"></div>
    </div>
    <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.title' | translate: upgradeData" class="title"></div>
    <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.p1' | translate: upgradeData" class="message"></div>
    <div class="actions">
        <button (click)="signUp($event)"
                class="action"
                color="primary"
                mat-flat-button>
                <span *spinOn="isFormSubmitting"
                      [innerHTML]="'deliveryDefenseSubscription.' + mode + '.action.yes' | translate: upgradeData"></span>
        </button>
        <button (click)="cancelSubscription($event)"
                [disabled]="isFormSubmitting"
                class="action ups-stroked-button"
                mat-stroked-button>
            <span [innerHTML]="'deliveryDefenseSubscription.' + mode + '.action.no' | translate: upgradeData"></span>
        </button>
    </div>
</ng-template>

<ng-template #downgrade>
    <div class="dialog-header">
        <img alt="DeliveryDefense" src="assets/images/logos/logo-dd-shipping-intelligence.svg">
        <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.remark' | translate: downgradeData" class="remark"></div>
    </div>
    <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.title' | translate: downgradeData"
         class="title"></div>
    <div [innerHTML]="'deliveryDefenseSubscription.' + mode + '.p1' | translate: downgradeData"
         class="message"></div>
    <div class="actions">
        <button (click)="signUp($event)"
                class="action"
                color="primary"
                mat-flat-button>
                <span *spinOn="isFormSubmitting"
                      [innerHTML]="'deliveryDefenseSubscription.' + mode + '.action.yes' | translate: downgradeData"></span>
        </button>
        <button (click)="cancelSubscription($event)"
                [disabled]="isFormSubmitting"
                class="action ups-stroked-button"
                mat-stroked-button>
            <span [innerHTML]="'deliveryDefenseSubscription.' + mode + '.action.no' | translate: downgradeData"></span>
        </button>
    </div>
</ng-template>
